(function (scope) {
  'use strict';

  function validPet(pet) {
    return pet && typeof pet.name === 'string' && pet.name.trim().length > 0 && pet.name.length <= 50 &&
      ['dog', 'cat'].indexOf(pet.species) !== -1 && Number.isFinite(Number(pet.weightKg)) && Number(pet.weightKg) > 0 &&
      Number.isInteger(Number(pet.ageYears)) && Number(pet.ageYears) >= 0;
  }

  function attach(root, form, restored) {
    var seed = root.querySelector('[data-pet-profile-seed]');
    if (!seed) return null;
    var data;
    try { data = JSON.parse(seed.dataset.petProfileSeed); } catch (error) { return null; }
    var pets = data && Array.isArray(data.pets) ? data.pets.filter(validPet) : [];
    var select = root.querySelector('[data-saved-pet]');
    var panel = root.querySelector('[data-saved-pets]');
    var status = root.querySelector('[data-profile-status]');
    var sessionKey = 'vikis.petDraft.v1.' + (seed.dataset.customerId || 'guest');
    var draft = null;
    try {
      draft = JSON.parse(scope.sessionStorage.getItem(sessionKey));
      if (!draft || !validPet(draft.pet) || Date.now() - draft.savedAt > 86400000) draft = null;
    } catch (error) {}

    pets.forEach(function (pet, index) {
      var option = document.createElement('option');
      option.value = String(index);
      option.textContent = pet.name + ' · ' + pet.species;
      select.appendChild(option);
    });
    panel.hidden = pets.length === 0;

    function apply(pet) {
      form.elements.petName.value = pet.name;
      form.elements.species.value = pet.species;
      ['ageYears', 'ageMonths', 'weightKg'].forEach(function (key) {
        form.elements[key].value = pet[key] === null || pet[key] === undefined ? '' : String(pet[key]);
      });
      form.elements.activity.value = ['low', 'moderate', 'high'].indexOf(pet.activity) !== -1 ? pet.activity : 'moderate';
      form.elements.bodyCondition.value = ['underweight', 'optimum', 'overweight'].indexOf(pet.bodyCondition) !== -1 ? pet.bodyCondition : 'unsure';
      form.elements.hasHealthNeeds.checked = pet.hasHealthNeeds === true;
      form.elements.hasDietaryRestrictions.checked = pet.hasDietaryRestrictions === true;
      form.elements.healthNotes.value = pet.healthNotes || '';
      form.elements.allergyNotes.value = pet.allergyNotes || '';
      if (pet.hasHealthNeeds || pet.hasDietaryRestrictions) root.querySelector('.vpc__optional').open = true;
      status.hidden = false;
      status.textContent = seed.dataset.restoredMessage;
      if (pet.observedAt) status.textContent += ' ' + seed.dataset.savedLabel + ' ' + pet.observedAt.slice(0, 10) + '.';
      restored(pet.id || null);
    }

    select.addEventListener('change', function () {
      if (select.value === '') {
        form.reset();
        status.hidden = true;
        restored(null);
        return;
      }
      var pet = pets[Number(select.value)];
      if (pet) apply(pet);
    });
    if (draft) apply(draft.pet);

    return {
      remember: function (input, id) {
        var pet = {
          id: id || null, name: input.petName, species: input.species,
          ageYears: input.ageYears, ageMonths: input.ageMonths, weightKg: input.weightKg,
          activity: input.activity || null, bodyCondition: input.bodyCondition || null,
          hasHealthNeeds: input.hasHealthNeeds, healthNotes: input.healthNotes,
          hasDietaryRestrictions: input.hasDietaryRestrictions, allergyNotes: input.allergyNotes
        };
        try { scope.sessionStorage.setItem(sessionKey, JSON.stringify({ pet: pet, savedAt: Date.now() })); } catch (error) {}
      },
      reset: function () {
        select.value = '';
        status.hidden = true;
        try { scope.sessionStorage.removeItem(sessionKey); } catch (error) {}
      }
    };
  }

  var api = { attach: attach, validPet: validPet };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else scope.VikisPetProfiles = api;
})(typeof window !== 'undefined' ? window : globalThis);
